import * as Sentry from "@sentry/vue";
import { getEnv } from '@/plugins/getEnv.js';

const SENTRY_DSN = 'https://6eff77c2db38e04ec8604cd50afe47b0@o4503936362872832.ingest.us.sentry.io/4509157233524736';

export let useSentry = (app, router) => {
  const env = getEnv();
  console.log(env)
  if (env === 'local') return;
  Sentry.init({
    app,
    dsn: SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration()
    ],  
    environment: env, // 'preprod' ou 'prod'
    release: "merrios_0.4",
    tracesSampleRate: 0.1, 
    tracePropagationTargets: [/^https:\/\/api\.merriosfid\.digiworks\.fr/, /^https:\/\/merriosfid\.digiworks\.fr/, /^https:\/\/api2\.offres-delices\.fr/, /^https:\/\/api3\.offres-delices\.fr/, /^https:\/\/offres-delices\.fr/, /^https:\/\/offres\.comptoirdesdouceurs\.com/, /^https:\/\/offres\.tabledejeannette\.com/, /^https:\/\/offres\.editionsbienetre\.com/, /^https:\/\/offres\.cavedejulien\.com/, /^https:\/\/offres\.institutvivianefrance\.com/],
    replaysSessionSampleRate: env === 'prod' ? 0 : 0.1,
    replaysOnErrorSampleRate: env === 'prod' ? 0 : 0.25,
  });
}